import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhone, faMapMarkerAlt, faEnvelope, faClock, faPaperPlane } from '@fortawesome/free-solid-svg-icons';
import { useTheme } from '../contexts/ThemeContext';
import '../@style/ContactPage.css';
import wpIcon from '../assets/icons/wp.png';

const ContactPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    subject: '',
    message: ''
  });

  const [isSubmitting, setIsSubmitting] = useState(false);
  
  const { isDarkMode } = useTheme();

  useEffect(() => {
    const timer = setTimeout(() => {
      // Make hero elements visible immediately
      const heroElements = document.querySelectorAll('.contact-hero .fade-in-up');
      heroElements.forEach(element => {
        element.classList.add('initial');
      });

      const observerOptions = {
        threshold: 0.05,
        rootMargin: '0px 0px -100px 0px'
      };

      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('animate');
          } else {
            // Element viewport'tan çıktığında animasyon sınıfını kaldır
            entry.target.classList.remove('animate');
          }
        });
      }, observerOptions);

      // Observe all animated elements except hero elements
      const animatedElements = document.querySelectorAll('.fade-in-up:not(.contact-hero .fade-in-up), .fade-in-left, .fade-in-right, .scale-in');
      
      animatedElements.forEach(element => {
        observer.observe(element);
      });

      return () => {
        animatedElements.forEach(element => {
          observer.unobserve(element);
        });
      };
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    
    // Simüle edilmiş form gönderimi
    setTimeout(() => {
      alert('Mesajınız başarıyla gönderildi! En kısa sürede size dönüş yapacağız.');
      setFormData({
        name: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
      });
      setIsSubmitting(false);
    }, 1500);
  };

  return (
    <div className={`contact-page ${isDarkMode ? 'dark-mode' : ''}`}>
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="container">
          <h1 className="fade-in-up">İletişim</h1>
          <p className="fade-in-up">Bizimle iletişime geçin, size yardımcı olmaktan mutluluk duyarız</p>
        </div>
      </section>

      {/* Contact Information Section */}
      <section className="contact-info">
        <div className="container">
          <div className="info-grid">
            <div className="info-card fade-in-up">
              <div className="info-icon">
                <FontAwesomeIcon icon={faPhone} />
              </div>
              <h3>Telefon</h3>
              <p>0412 330 01 21</p>
              <p>Pazartesi - Cuma: 09:00 - 18:00</p>
            </div>

            <div className="info-card fade-in-up info-card-branches">
              <div className="info-icon">
                <FontAwesomeIcon icon={faMapMarkerAlt} />
              </div>
              <h3>Şubelerimiz</h3>
              <p><strong>Şube 1:</strong> Gazi Cad. Tarihi Kuyumcular Çarşısı No: 25 Sur/D.BAKIR</p>
              <p><strong>Şube 2:</strong> Gazi Cad. Hasanpaşa Hanı Altı No: D Sur/D.BAKIR</p>
              <p><strong>Şube 3:</strong> Mahabad Bulvarı 75 Yol Üzeri No: 69 Kayapınar/D.BAKIR</p>
            </div>

            <div className="info-card fade-in-up">
              <div className="info-icon">
                <FontAwesomeIcon icon={faEnvelope} />
              </div>
              <h3>E-posta</h3>
              <p>info@engkiymetlimadenler.com</p>
              <p>destek@engkiymetlimadenler.com</p>
            </div>

            <div className="info-card fade-in-up">
              <div className="info-icon">
                <FontAwesomeIcon icon={faClock} />
              </div>
              <h3>Çalışma Saatleri</h3>
              <p>Pazartesi - Cuma: 09:00 - 18:00</p>
              <p>Cumartesi: 09:00 - 14:00</p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Form Section */}
      <section className="contact-form-section">
        <div className="container">
          <div className="form-content">
            <div className="form-info fade-in-left">
              <h2>Bize Ulaşın</h2>
              <p>
                Altın ve döviz işlemleriniz için profesyonel destek almak istiyorsanız, 
                aşağıdaki formu doldurarak bizimle iletişime geçebilirsiniz. 
                Uzman ekibimiz en kısa sürede size dönüş yapacaktır.
              </p>
              
              <div className="contact-features">
                <div className="feature-item">
                  <div className="feature-icon">📞</div>
                  <div>
                    <h4>Hızlı Yanıt</h4>
                    <p>24 saat içinde yanıt garantisi</p>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">💬</div>
                  <div>
                    <h4>WhatsApp Destek</h4>
                    <p>Anlık mesajlaşma ile hızlı iletişim</p>
                  </div>
                </div>
                
                <div className="feature-item">
                  <div className="feature-icon">🎯</div>
                  <div>
                    <h4>Uzman Destek</h4>
                    <p>Deneyimli ekip ile profesyonel hizmet</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="contact-form fade-in-right">
              <form onSubmit={handleSubmit}>
                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="name">Ad Soyad *</label>
                    <input
                      type="text"
                      id="name"
                      name="name"
                      value={formData.name}
                      onChange={handleInputChange}
                      required
                      placeholder="Adınız ve soyadınız"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="email">E-posta *</label>
                    <input
                      type="email"
                      id="email"
                      name="email"
                      value={formData.email}
                      onChange={handleInputChange}
                      required
                      placeholder="E-posta adresiniz"
                    />
                  </div>
                </div>

                <div className="form-row">
                  <div className="form-group">
                    <label htmlFor="phone">Telefon</label>
                    <input
                      type="tel"
                      id="phone"
                      name="phone"
                      value={formData.phone}
                      onChange={handleInputChange}
                      placeholder="Telefon numaranız"
                    />
                  </div>
                  
                  <div className="form-group">
                    <label htmlFor="subject">Konu *</label>
                    <select
                      id="subject"
                      name="subject"
                      value={formData.subject}
                      onChange={handleInputChange}
                      required
                    >
                      <option value="">Konu seçiniz</option>
                      <option value="kiymetli-maden-alis">Kıymetli Maden Alış</option>
                      <option value="kiymetli-maden-satis">Kıymetli Maden Satış</option>
                      <option value="doviz-islemleri">Döviz İşlemleri</option>
                      <option value="toptan-satis">Toptan Satış</option>
                      <option value="genel-bilgi">Genel Bilgi</option>
                      <option value="diger">Diğer</option>
                    </select>
                  </div>
                </div>

                <div className="form-group">
                  <label htmlFor="message">Mesaj *</label>
                  <textarea
                    id="message"
                    name="message"
                    value={formData.message}
                    onChange={handleInputChange}
                    required
                    rows="5"
                    placeholder="Mesajınızı buraya yazın..."
                  ></textarea>
                </div>

                <button 
                  type="submit" 
                  className="submit-btn"
                  disabled={isSubmitting}
                >
                  <FontAwesomeIcon icon={faPaperPlane} />
                  {isSubmitting ? 'Gönderiliyor...' : 'Mesaj Gönder'}
                </button>
              </form>
            </div>
          </div>
        </div>
      </section>

      {/* Map Section */}
      <section className="map-section">
        <div className="container">
          <h2 className="fade-in-up">Konumumuz</h2>
          <div className="map-container fade-in-up">
            <iframe 
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3147.7637446800245!2d40.234423276335484!3d37.91258455420885!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x407520387420481b%3A0x85a92495f6aa5fc3!2zS3V5dW1jdWxhciDDh2FyxZ_EsXPEsQ!5e0!3m2!1str!2str!4v1755528455020!5m2!1str!2str" 
              width="100%" 
              height="450" 
              style={{border:0}} 
              allowFullScreen="" 
              loading="lazy" 
              referrerPolicy="no-referrer-when-downgrade"
              title="Mağaza Konumu"
              className="contact-map"
            ></iframe>
          </div>
        </div>
      </section>

      {/* WhatsApp Contact */}
      <section className="whatsapp-contact">
        <div className="container">
          <div className="whatsapp-content">
            <div className="whatsapp-icon scale-in">
              <img src={wpIcon} alt="WhatsApp" />
            </div>
            <div className="whatsapp-text fade-in-left">
              <h3>Telefon ile Hızlı İletişim</h3>
              <p>Anlık fiyat bilgisi ve hızlı işlemler için bizi arayın</p>
            </div>
            <a href="tel:+904123300121" className="whatsapp-btn scale-in">
              0412 330 01 21
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default ContactPage;
